/* eslint-disable @typescript-eslint/no-explicit-any */
import { toast } from '../../../utils/notification';

export const addNodesGraph = async (params: any, componentParams: any) => {

  if(Array.isArray(params.data)) return toast.info('This Function limmited on one node. Multiple nodes are selected');

  if(!componentParams) return null;
  await componentParams.addNodesCytoscape(params.objects, componentParams?.itemPosition);
};
